;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  SymbolName as IconName,
  spriteHref as iconSpriteHref,
} from '../generated'

type OutlineIconName = Extract<IconName, `heroicons/outline/${string}`>

export { type IconName, type OutlineIconName, iconSpriteHref }
